import React, { useState } from 'react';
import cx from 'classnames';

import { locale } from '@trqk/utils';

import { Dropdown } from '..';

import ascapCSVHelp from '../../assets/images/ascap_csv_help.png';
import bmiCSVHelp from '../../assets/images/bmi_csv_help.png';
import sesacCSVHelp from '../../assets/images/sesac_csv_help.png';

const options: DropdownOption<string>[] = [
    {
        label: 'ASCAP',
        value: 'ASCAP',
    },
    {
        label: 'BMI',
        value: 'BMI',
    },
    {
        label: 'SESAC',
        value: 'SESAC',
    },
];

export const CSVHelpInfo = (): JSX.Element => {
    const [pro, setPro] = useState(options[0].value);

    return (
        <div className="respond-to-mouse">
            <span className="mr-2 text-tertiary-400 italic">
                {locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.VIEW_SCREENSHOT_FOR}
            </span>
            <Dropdown<string>
                defaultIndex={0}
                options={options}
                handleChange={(value: string): void => {
                    setPro(value);
                }}
            />
            <img
                className={cx({
                    hidden: pro !== 'ASCAP',
                })}
                width="530px"
                src={ascapCSVHelp}
                alt={locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.ALT_TEXT}
            />
            <img
                className={cx({
                    hidden: pro !== 'BMI',
                })}
                width="530px"
                src={bmiCSVHelp}
                alt={locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.ALT_TEXT}
            />
            <img
                className={cx({
                    hidden: pro !== 'SESAC',
                })}
                width="530px"
                src={sesacCSVHelp}
                alt={locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.ALT_TEXT}
            />
        </div>
    );
};
